export function currencyDigits(currency = 'VND') {
  const code = currency.toUpperCase();
  if (['BHD', 'IQD', 'JOD', 'KWD', 'LYD', 'OMR', 'TND'].includes(code)) return 3;
  if (['CLF', 'UYW'].includes(code)) return 4;
  return ['AFN', 'ALL', 'BIF', 'CLP', 'COP', 'DJF', 'GNF', 'HUF', 'IDR', 'IRR', 'ISK',
    'JPY', 'KMF', 'KPW', 'KRW', 'LAK', 'LBP', 'MGA', 'MMK', 'PKR', 'PYG', 'RWF',
    'SLL', 'SOS', 'SYP', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF', 'YER'].includes(code) ? 0 : 2;
}
// Currency digits are presentation metadata only; never a monetary precision cap.
export { ExactDecimal, isStorageDecimal } from './decimal';
import { ExactDecimal } from './decimal';
function numeric(operation: () => ExactDecimal | null) {
  try { return operation()?.toNumberExact() ?? NaN; } catch { return NaN; }
}
export function sumMoney(values: number[]) {
  return numeric(() => values.reduce((sum, value) => sum.add(ExactDecimal.from(value)), ExactDecimal.from(0)));
}
export function addMoney(a: number, b: number) { return sumMoney([a, b]); }
export function subtractMoney(a: number, b: number) { return numeric(() => ExactDecimal.from(a).subtract(ExactDecimal.from(b))); }
export function multiplyMoney(a: number, b: number) { return numeric(() => ExactDecimal.from(a).multiply(ExactDecimal.from(b))); }
export function divideMoney(a: number, b: number) { return numeric(() => ExactDecimal.from(a).divideTruncated(ExactDecimal.from(b), 2)); }
export function proportionMoney(amount: number, numerator: number, denominator: number) {
  return numeric(() => ExactDecimal.from(amount).multiply(ExactDecimal.from(numerator)).divideTruncated(ExactDecimal.from(denominator), 2));
}
export function allocateMoney(amount: number, weights: number[], _currency?: string): number[] | null {
  try {
    const positive = weights.map(value => ExactDecimal.from(Number.isFinite(value) ? Math.max(0, value) : 0));
    const total = positive.reduce((sum, value) => sum.add(value), ExactDecimal.from(0));
    if (!weights.length) return [];
    if (total.units === 0n) return null;
    if (positive.filter(weight => weight.units !== 0n).length === 1) return positive.map(weight => weight.units !== 0n ? amount : 0);
    const shares = positive.map(weight => ExactDecimal.from(amount).multiply(weight).divideTruncated(total, 2));
    if (shares.some(share => share === null)) return null;
    return shares.map(share => share!.toNumberExact());
  } catch { return null; }
}
